import Video from '../modules/video';
import VideoModal from '../modules/video-modal';
import Timeline from '../modules/timeline';
import FormGeneral from '../modules/form-general';
import Carousel from '../modules/carousel';
import Testimonial from "../modules/testimonial";
import StatsMulti from "../modules/stats-multi";
import ContentCards from "../modules/content-cards";
import SustainabilityCalculator from "../modules/sustainability-calculator";
import AccordionModule from "../modules/accordion-module";
import MoreLinks from "../modules/more-links";

class DefaultPageTemplate {

  constructor(root) {
      this.container = root;
      this.videos = [];
      this.modals = [];
      this.timelines = [];
      this.forms = [];
      this.carousels = [];
      this.testimonials = [];
      this.statistics = [];
      this.contentCards = [];
      this.accordionModules = [];
      this.moreLinks = [];
      this.initSustainabilityCalculator();

      this.container.querySelectorAll('.video-container').forEach((n) => {
        if (n.closest('.video-modal')) {
          this.initModal(n.closest('.video-modal'), this);
        } else {
          this.initVideo(n, this)
        }
      });
      this.container.querySelectorAll('.timeline').forEach(n => this.initTimeline(n, this));
      this.container.querySelectorAll('.form--general').forEach(n => this.initForm(n, this));
      this.container.querySelectorAll('.carousel').forEach(n => this.initCarousel(n, this));
      this.container.querySelectorAll('.testimonial').forEach(n => this.initTestimonials(n, this));
      this.container.querySelectorAll('.stats-module-multi').forEach(n => this.initStats(n, this));
      this.container.querySelectorAll('.content-cards').forEach(n => this.initContentCards(n, this));
      this.container.querySelectorAll('.accordion-module').forEach(n => this.initProductDetailStyleAccordions(n, this));

      this.initClosingCards();
  }

    initClosingCards() {
        this.container.querySelectorAll('.more-links').forEach(n => {
            this.moreLinks.push(new MoreLinks(n));
        });
    }

  initProductDetailStyleAccordions(node, instance) {
      instance.accordionModules.push(new AccordionModule(node));
  }

    initSustainabilityCalculator() {
        this.formContainer = this.container.querySelector('.calculator__form');
        if(this.formContainer) {
            this.calculatorForm = new SustainabilityCalculator(this.formContainer);
        }
    }

  initContentCards(node, instance) {
      instance.contentCards.push(new ContentCards(node));
  }

  initStats(node, instance) {
      instance.statistics.push(new StatsMulti(node));
  }

  initTestimonials(node, instance) {
      instance.testimonials.push(new Testimonial(node));
  }

  initVideo(node, instance) {
    instance.videos.push(new Video(node));
  }

  initModal(node, instance) {
    instance.modals.push(new VideoModal(node));
  }

  initTimeline(node, instance) {
    instance.timelines.push(new Timeline(node));
  }

  initForm(node, instance) {
    instance.forms.push(new FormGeneral(node));
  }

  initCarousel(node, instance) {
    instance.carousels.push(new Carousel(node));
  }

}

export {DefaultPageTemplate}
